// Use $ instead of jQuery without replacing global $
(function ($) {
  /* Search overlay functionality */
  
  $('header .search').on('click',function (e) {
    e.stopPropagation();
    console.log("object1")
    
// search on mobile
    var $winWidth = $(window).width();
    if ($winWidth < 992) {
      $('header .mobile-search').addClass('active');
      $('header .secondary-nav').addClass('active');
    } else {
      $('header .mobile-search').removeClass('active');
      $('header .secondary-nav').removeClass('active');
    }

    $('.main-nav').addClass('expand-search');

    setTimeout(function () {
      $(this).parent().parent().addClass('search-active');
    },100);

    $(this).parent().parent().addClass('search-active');


    setTimeout(function () {
      $(".search-input").focus();
    }, 50);
  });

  $('header .mobile-search .cross-outer').on('click',function (e) {
    e.stopPropagation();
    // search on mobile
    var $winWidth = $(window).width();
    if ($winWidth < 992) {
      $('header .mobile-search').removeClass('active');
      $('header .secondary-nav').removeClass('active');
    } else {
      $('header .mobile-search').removeClass('active');
      $('header .secondary-nav').removeClass('active');
    }
  });


  $('.main-nav .cross-outer').on('click',function (e) {
    e.stopPropagation();
    setTimeout(function () {
      $('.main-nav').removeClass('expand-search');
      $(".search-input").val('');
    }, 100);

    setTimeout(function () {
      $('header nav .nav-wrap .main-nav > ul').removeClass('search-active');
    }, 500);
  });

  $(document).on('click','header nav .secondary-nav ul.resp-search form .cross-outer', function (e) {
    e.stopPropagation();
    setTimeout(function () {
      $('header nav .secondary-nav ul.resp-search').removeClass('search-active');
    }, 100);
  });

  $(document).on('click',function (e) {
    e.stopPropagation();
    // console.log('test');
    setTimeout(function () {
      $('header nav .secondary-nav ul.resp-search').removeClass('search-active');
    }, 100);
  });


  $('.main-nav .search-input').on('click',function (e) {
    e.stopPropagation();
  });


  $(window).on('load resize', function () {
    var winWidth = $(window).width();
    if (winWidth < 992) {
      $('.main-nav').removeClass('expand-search');
      $('header nav .nav-wrap .main-nav > ul, header nav .secondary-nav ul.resp-search').removeClass('search-active');
    } else {
      $('header .mobile-search').removeClass('active');
      $('header .secondary-nav').removeClass('active');
      $('.main-nav').removeClass('expand-search');
    }
  });


})(jQuery);